import classnames from 'classnames'
import React from 'react'

import { shortFormatNumber } from '../../../../util'
import { ManagerFundItemData } from '../../constants'
import { TickerButton } from '../TickerButton'

type Props = Pick<ManagerFundItemData, 'topInvestments'>

export function FundHoldingsSection({ topInvestments }: Props) {
  const hasHoldings = topInvestments.length > 0
  return (
    <div className={classnames('min-h-24', { 'flex items-center justify-center': !hasHoldings })}>
      {!hasHoldings && (
        <span className="text-2xs text-muted-2">No portfolio holdings have been reported in the last quarter.</span>
      )}
      {topInvestments.map(({ ticker, name, value, percentageOfPortfolio, putCall, boxoverData }, index) => (
        <div className="flex h-6 items-center" key={index}>
          <div className="w-18">
            <TickerButton
              className="text-2xs"
              ticker={ticker}
              name={name}
              putCall={putCall}
              boxoverData={boxoverData}
            />
          </div>
          <span className="flex-1 truncate text-2xs">{name}</span>
          <span className="w-16 text-right text-2xs">
            {shortFormatNumber(percentageOfPortfolio, { defaultValue: '—' })}
            {Number.isFinite(percentageOfPortfolio) ? '%' : ''}
          </span>
          <span className="w-17 text-right text-2xs">{shortFormatNumber(value, { defaultValue: '—' })}</span>
        </div>
      ))}
    </div>
  )
}
